import * as Yup from 'yup';

const initialValues = (props) => ({ firstName: props.first_name || '', lastName: props.last_name || '', phoneNumber: props.phone_number || '' });

const validationSchema = Yup.object({
  firstName: Yup.string().trim().max(100, 'Must be 100 characters or less').required('Required'),
  lastName: Yup.string().trim().max(100, 'Must be 100 characters or less').required('Required'),
  phoneNumber: Yup.string().trim().min(10, 'Must be 10 characters').max(14, 'Must be 10 characters').required('Required'),
});

/* eslint-disable import/prefer-default-export */
export { initialValues, validationSchema };
